module.exports = __webpack_public_path__ + "img/新品推荐示例图.47792de2.jpeg";